import { Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  BackAction,
  SelectedFilterAction,
  GetChatMessagesAction,
  GetMessagesAction,
  NewMessageReceivedAction,
  SetActiveMessageAction,
  SendMessageAction,
  CheckMessagesAction,
  ChangeStatusReceivedAction,
  ChangeTrackingReceivedAction,
  SendGlobalMessageAction,
  ResetStateAction,
  MessengerReconnectionAction,
  IsGlobalMessageOpenAction,
} from './messenger.action';
import { MessengerSelector } from './messenger.selector';
import { IChatMessage, IFilterAction, IFilterState, IMachineMessage } from '../../interfaces/messenger';
import { IMachineStatusChange } from '../../interfaces/signal-r/machine-status-change';
import { IMachineTracking } from '../../interfaces/signal-r/machine-tracking';

@Injectable({ providedIn: 'root' })
export class MessengerFacade {
  // @Select(MessengerState.chatHasNonReadMessages) nonReadMessages$: Observable<number>;
  // @Select(MessengerState.closeAndOpenChatBox) closeAndOpenChatBox$: Observable<string>;

  @Select(MessengerSelector.messages) machineMessages$: Observable<IMachineMessage[]>;
  @Select(MessengerSelector.unreadMessages) unreadMessages$: Observable<IMachineMessage[]>;
  @Select(MessengerSelector.activeMessage) activeMessage$: Observable<IMachineMessage>;
  @Select(MessengerSelector.isChatLoading) isChatLoading$: Observable<boolean>;
  @Select(MessengerSelector.messengerFilter) messengerFilter$: Observable<IFilterState>;
  @Select(MessengerSelector.messageUpdated) messageUpdated$: Observable<IChatMessage>;
  @Select(MessengerSelector.isSendingMessage) isSendingMessage$: Observable<boolean>;
  @Select(MessengerSelector.isCheckingMessages) isCheckingMessages$: Observable<boolean>;
  @Select(MessengerSelector.messagesChecked) messagesChecked$: Observable<boolean>;
  @Select(MessengerSelector.isGlobalMessageOpen) isGlobalMessageOpen$: Observable<boolean>;
  @Select(MessengerSelector.sidebarNotification) sidebarNotification$: Observable<number>;
  @Select(MessengerSelector.newTracking) newTracking$: Observable<IMachineTracking>;

  constructor(private store: Store) {}

  public getMachinesMessages(): void {
    this.store.dispatch(new GetMessagesAction());
  }

  public newMessageReceived(message: IChatMessage): void {
    this.store.dispatch(new NewMessageReceivedAction(message));
  }

  public changeStatusReceived(status: IMachineStatusChange): void {
    this.store.dispatch(new ChangeStatusReceivedAction(status));
  }
  public changeTrackingReceived(tracking: IMachineTracking): void {
    this.store.dispatch(new ChangeTrackingReceivedAction(tracking));
  }

  public setActiveMessage(machineMessage: IMachineMessage) {
    this.store.dispatch(new SetActiveMessageAction(machineMessage));
  }

  public getChatMessages(page: number) {
    this.store.dispatch(new GetChatMessagesAction(page));
  }

  public back(): void {
    this.store.dispatch(new BackAction());
  }

  public selectedFilter(filter: IFilterAction): void {
    this.store.dispatch(new SelectedFilterAction(filter));
  }

  public sendMessage(message: string): void {
    this.store.dispatch(new SendMessageAction(message));
  }

  public checkMessages(): void {
    this.store.dispatch(new CheckMessagesAction());
  }

  public sendGlobalMessage(globalMessage: string): void {
    this.store.dispatch(new SendGlobalMessageAction(globalMessage));
  }

  public resetState(): void {
    this.store.dispatch(new ResetStateAction());
  }

  public messengerReconnection(): void {
    this.store.dispatch(new MessengerReconnectionAction());
  }

  public isGlobalMessageOpen(value: boolean): void {
    this.store.dispatch(new IsGlobalMessageOpenAction(value));
  }
}
